module.exports = __webpack_public_path__ + "static/media/coding.eff3c155.gif";